// threejs modules made with <3 for 0+x
import intro from './introAscii';
import expertAscii from './expertAscii';
import aboutAscii from './aboutAscii';
import backgroundAnim from './backgroundAnim';
import tid from '../modules/tid';

import homePage from './homePage';
import expertPage from './expertPage';
import expertsPage from './expertsPage';
// import aboutPage from './aboutPage';

export default class page {
  constructor () {
    if($('html').hasClass('home')) {
      new homePage();
    }

    if($('html').hasClass('experts')) {
      new expertsPage();
    }

    $('.menu-but').click(function(e){
      e.preventDefault();
      $('.nav').toggleClass('open');
    });

    $('.nav-backdrop').click(function(e){
      e.preventDefault();
      $('.nav').removeClass('open');
    });

    MOBSIZE = window.innerWidth <= 767;

    this.repositionThings();

    $('.wrap').addClass('in');

    $(window).on('pageshow', function(){
      $('.wrap').addClass('in');
      $('body').removeClass('blackout');
    })

    // setTimeout(function(){
      window.backgroundAnim = new backgroundAnim();

      // run homepage ascii + time
      if($('html').hasClass('home')){
        setTimeout(function(){
          window.intro = new intro();
          new tid();
        }, 100);
      }

      // run portrait ascii for expert pages
      if($('html').hasClass('expert')) window.expertAscii = new expertAscii();
      if($('html').hasClass('about')) window.aboutAscii = new aboutAscii();
    // }, 50);

    if($('html').hasClass('expert')) new expertPage();

    $('.gui .toggle').click(function(e){
      e.preventDefault();
      $(this).parent('.gui').toggleClass('vis');
    });
  }

  repositionThings(){
    $('.readmore').each(function(){
      let x = Math.random()*10 + 2 + 'rem';
      let y = Math.random()*10 + 10 + 'rem';
      $(this).css({
        'right' : x,
        'bottom' : y,
      });
    });

    $('.gui').each(function(){
      let x = Math.random()*10 + 2 + 'rem';
      let y = Math.random()*10 + 1 + 'rem';
      $(this).css({
        'right' : x,
        'bottom' : y,
      });
    });

    // $('.nav--main .nav-item').each(function(){
    //   if(!MOBSIZE) {
    //     let xRand = Math.random()*8 - 4;
    //     if($(this).is(':last-child')) { xRand = -Math.abs(xRand); }
    //     // $(this).css('top', Math.random()*50+'%');
    //     $(this).css('left', xRand+'%');
    //   } else {
    //     $(this).css({
    //       'left' : '',
    //       'top' : '',
    //     });
    //   }
    // });

    if(!MOBSIZE) {
      $('.tid').css({
        'top' : Math.random()*25+'%',
        'left' : 20 + Math.random()*20+'%',
      });
    } else {
      $('.tid').css({
        'top' : 40 + (Math.random()*25)+'%',
        'left' : 5 + Math.random()*20+'%',
      });
    }

    $('.wrap--content h2').css({
      'left' : 5 + Math.random()*10+'%',
    });

    var floatAvailableY = (window.innerHeight*.8) / $('.float').length;
      // console.log(floatAvailableY);

    // Easy url copy on contact page
    if($('html').hasClass('contact')){
      $('.floaty--text a').each(function(){
        var link = $('<a href="#" class="copymail">[COPY]</a>');
        var t = $(this).text();
        $(link).on('click', function(e){
          e.preventDefault();
          navigator.clipboard.writeText(t);
          $(this).text('[COPIED!]');
          const _this = this;
          setTimeout(function(){
            $(_this).text('[COPY]');
          }, 2000);
        });
        $(link).insertAfter(this);
      });
    }

    if(MOBSIZE && $('html').hasClass('contact')){
      floatAvailableY = ((window.innerHeight - (window.innerWidth*.63)) / $('.float').length) - 100;
    }

    $('.float').each(function(idx){
      let pxPosY = parseInt(Math.random()*floatAvailableY + 10 + (floatAvailableY*idx)) + (100);
      $(this).css('top', pxPosY);
      $(this).css('left', (Math.random()*10 + 2 + (20*idx)) +'%');
    });
  }
}
